import { StateSchema } from '../../../../../app/providers/StoreProvider/config/StateSchema';

export const getAddressLoading = (state: StateSchema) => state.address.loading;
